<form [formGroup]="vehicleDetailsForm">
  <div class="card">
    <div class="card-body">
      <div>
        {{ selectedCustomerVehicle?.VehicleFullDescription }}
      </div>
      <div class="form-group row pt-3">
        <label for="regoNumber" class="col-4 col-xl-2">Registration*</label>
        <div class="col-8 col-xl-5">
          <input
            type="text"
            class="form-control w-100"
            name="regoNumber"
            [class.is-invalid]="vehicleDetailsForm.controls.regoNumber.touched && vehicleDetailsForm.controls.regoNumber.errors"
            formControlName="regoNumber"
            (keyup.enter)="pressEnter()"
            [value]="vehicleDetailsForm.controls.regoNumber.value | uppercase"
            autofocus
          />
          <div
            class="invalid-feedback"
            *ngIf="vehicleDetailsForm.controls.regoNumber.touched && vehicleDetailsForm.controls.regoNumber.errors?.required"
          >
            This field is required
          </div>
          <div
            class="invalid-feedback"
            *ngIf="vehicleDetailsForm.controls.regoNumber.touched && vehicleDetailsForm.controls.regoNumber.errors?.pattern"
          >
            The registration number is invalid
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="regoState" class="col-4 col-xl-2">State</label>
        <div class="col-8 col-xl-5">
          <ng-select [items]="stateList" formControlName="regoState" bindLabel="StateDescription" bindValue="StateCode" class="w-100"> </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label for="country" class="col-4 col-xl-2">Country</label>
        <div class="col-8 col-xl-5">
          <ng-select
            [items]="lookupLists?.countryList"
            formControlName="country"
            bindLabel="CountryDescription"
            bindValue="CountryCode"
            class="w-100"
          >
          </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label for="vinNumber" class="col-4 col-xl-2">VIN</label>
        <div class="col-8 col-xl-5">
          <input
            type="text"
            class="form-control w-100"
            name="vinNumber"
            [class.is-invalid]="vehicleDetailsForm.controls.vinNumber.touched && vehicleDetailsForm.controls.vinNumber.errors"
            formControlName="vinNumber"
            (keyup.enter)="pressEnter()"
          />
          <div
            class="invalid-feedback"
            *ngIf="vehicleDetailsForm.controls.vinNumber.touched && vehicleDetailsForm.controls.vinNumber.errors?.pattern"
          >
            The VIN is invalid
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="colourCode" class="col-4 col-xl-2">Colour Code</label>
        <div class="col-8 col-xl-5">
          <ng-select
            [items]="lookupLists?.colourList"
            formControlName="colourCode"
            bindLabel="ColoursDescription"
            bindValue="ColoursDescription"
            class="w-100"
          >
          </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label for="description" class="col-4 col-xl-2">Short description</label>
        <div class="col-8 col-xl-5">
          <input type="text" class="form-control w-100" name="shortDescription" formControlName="shortDescription" (keyup.enter)="pressEnter()" />
        </div>
      </div>
      <div *ngIf="selectedCustomerVehicle?.promoArray?.length" class="form-group row my-2">
        <label for="description" class="col-4 col-xl-2">Promotions</label>
        <div class="col-8">
          <div *ngFor="let promo of selectedCustomerVehicle?.promoArray">
            <div class="d-flex align-items-center justify-content-start">
              <mat-icon
                
                style="height: 40px"
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
                  <path
                    d="M260-320q25 0 42.5-17.5T320-380q0-25-17.5-42.5T260-440q-25 0-42.5 17.5T200-380q0 25 17.5 42.5T260-320Zm360 0q20 0 36-12t21-31q-20-4-38-13.5T606-401l-25-25q-10 8-15.5 20t-5.5 26q0 25 17.5 42.5T620-320Zm-460 40v-200 200Zm40 80v40q0 17-11.5 28.5T160-120h-40q-17 0-28.5-11.5T80-160v-320l84-240q6-18 21.5-29t34.5-11h140v55q0 6 .5 12.5T362-680H234l-42 120h255l80 80H160v200h560v-81q22-2 42.5-11t37.5-25v237q0 17-11.5 28.5T760-120h-40q-17 0-28.5-11.5T680-160v-40H200Zm400-520q17 0 28.5-11.5T640-760q0-17-11.5-28.5T600-800q-17 0-28.5 11.5T560-760q0 17 11.5 28.5T600-720Zm62 262L458-662q-8-8-13-19.5t-5-23.5v-155q0-25 17.5-42.5T500-920h155q12 0 23.5 5t19.5 13l204 204q17 17 17 42.5T902-613L747-458q-17 17-42.5 17T662-458Zm43-70 127-127-185-185H520v127l185 185Zm-29-156Z"
                  />
                </svg>
              </mat-icon>
              <span class="ms-2">{{ promo.promotionName + ' - ' + promo.promotionShortDescription }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
